var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('v-row',{staticClass:"mt-5"},_vm._l((_vm.cantidad),function(item,index){return _c('v-col',{key:index},[_c('v-skeleton-loader',{staticClass:"mx-auto",attrs:{"width":"300","type":"card"}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }